// @flow
import { StationLink } from './StationLink';

export type Player = 'STATSRADIO' | 'CUSTOM';

export type PlayerConfigurationData = {
  player: Player;
  statsRadioPlayer: StatsRadioPlayerData;
}

export type RecentlyPlayedSongsTheme = {
  backgroundColor: string;
  mainTextColor: string;
  secondaryText: string;
}

export type StationInformationTheme = {
  backgroundColor: string;
  textColor: string;
  linkHeaderColor: string;
  linkHeaderTextColor: string;
  linkBackgroundColor: string;
  linkTextColor: string;
}

export type HeaderTheme = {
  backgroundColor: string;
  iconColor: string;
  buttonColor: string;
}

export type StatsRadioPlayerThemeData = {
  backgroundColor: string;
  backgroundImage: any;
  backgroundImagePosition: string;
  hideBanner: boolean;

  header: HeaderTheme;
  stationInformation: StationInformationTheme;
  recentlyPlayedSongs: RecentlyPlayedSongsTheme;
}

export type StatsRadioPlayerStationInformationData = {
  display: boolean;
  description: string;
  name: string;
  logo: any;
  logoWidth: number;
  links: Array<StationLink>;
}

export type StatsRadioPlayerRecentlyPlayedSongsData = {
  display: boolean;
  maxSongs: number;
}

export type StatsRadioPlayerNowPlayingSongData = {
  display: boolean,
}

export type StatsRadioPlayerData = {
  theme: StatsRadioPlayerThemeData,
  stationInformation: StatsRadioPlayerStationInformationData,
  recentlyPlayedSongs: StatsRadioPlayerRecentlyPlayedSongsData,
  nowPlayingSong: StatsRadioPlayerNowPlayingSongData,
}

export const INITIAL_DATA: PlayerConfigurationData = {
  player: 'STATSRADIO',
  statsRadioPlayer: {
    theme: {
      backgroundColor: '#F5F5F5',
      backgroundImage: null,
      backgroundImagePosition: '50% 50%',
      hideBanner: true,

      header: {
        backgroundColor: '#0980c6',
        iconColor: 'black',
        buttonColor: 'white',
      },

      stationInformation: {
        backgroundColor: '#0980c6',
        textColor: 'white',
        linkHeaderColor: '#49aae2',
        linkHeaderTextColor: 'white',
        linkBackgroundColor: 'white',
        linkTextColor: 'black',
      },

      recentlyPlayedSongs: {
        backgroundColor: '#efefef',
        mainTextColor: 'black',
        secondaryText: 'gray',
      },
    },

    stationInformation: {
      display: true,
      description: '',
      name: '',
      logo: null,
      logoWidth: 100,
      links: [],
    },

    recentlyPlayedSongs: {
      display: true,
      maxSongs: 100,
    },

    nowPlayingSong: {
      display: false,
    },
  },
};




// WEBPACK FOOTER //
// ./src/statsradio/modules/radioConfiguration/domain/PlayerConfiguration.js